import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import * as FlatModels from '@medsurf/flat-models';

@Component({
    selector: 'medsurf-design-form-control-input-submit',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './submit.input.form-control.design.html',
    styleUrls: ['./submit.input.form-control.design.scss'],
    standalone: false
})
export class SubmitInputFormControlDesign {
  @Input() formField = true;
  @Input() inputClass: FlatModels.ButtonDesignModels.ButtonDesignClass = FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY;
  @Input() iconClass?: FlatModels.ButtonDesignModels.ButtonDefaultIcons;
  @Input() iconClassAfter?: FlatModels.ButtonDesignModels.ButtonDefaultIcons;
  @Input() label?: string;
  @Input() disabled = false;
}
